import axios from "axios";

export const fetchSignedUrls = async (fileKeys) => {
  try {
    if (!Array.isArray(fileKeys) || fileKeys.length === 0) {
      console.error("Invalid file keys");
      return;
    }

    const response = await fetch(
      `${process.env.REACT_APP_CRI_API}signedUrls`, // Adjust endpoint for multiple files
      {
        method: "POST", // Use POST for sending an array
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fileKeys }),
      }
    );

    const data = await response.json();

    if (data.urls && data.urls.length > 0) {
      // Open all files in new tabs
      data.urls.forEach((url) => {
        window.open(url, "_blank");
      });
    } else {
      console.error("Failed to retrieve signed URLs");
    }
  } catch (error) {
    console.error("Error fetching signed URLs:", error);
  }
};


export const fetchSignedUrlMedical = async (fileKey) => {
  try {
    if (!fileKey) return null;

  

    const response = await axios.post(
      `${process.env.REACT_APP_CRI_API}signedUrl`,
      { fileKey: fileKey }
    );

    return response.data?.url || null;
  } catch (error) {
    console.error("Error fetching signed URL:", error.response?.data || error.message);
    return null;
  }
};

export const fetchSignedUrl = async (fileKey) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_COLLEGE_ERP_API}signedUrl?fileKey=${fileKey}`
    );
    const data = await response.json();

    if (data.url) {
      console.log("Signed URL fetched:", data.url);
      return data.url;
      //  window.open(data.url, "_blank"); // Open the PDF in a new tab
    } else {
      console.error("Failed to get signed URL");
    }
  } catch (error) {
    console.error("Error fetching signed URL:", error);
  }
};

export const getSignedUploadUrlSupport = async (file, folderName) => {
  const response = await axios.get(
    `${process.env.REACT_APP_COLLEGE_ERP_API}get-upload-url`,
    {
      params: {
        fileName: file.name,
        folder: folderName,
        contentType: file.type,
      },
    }
  );
  return response.data; // { uploadUrl, fileKey }
};

export const uploadFileToS3 = async (uploadUrl, file) => {
  await axios.put(uploadUrl, file, {
    headers: { "Content-Type": file.type },
  });
};

export const uploadFileAndGetKey = async (file, folderName) => {
  const { uploadUrl, fileKey } = await getSignedUploadUrlSupport(
    file,
    folderName
  );
  await uploadFileToS3(uploadUrl, file);
  return fileKey;
};
